// Bild theme settings will be here until we have another theme for light poll
export const theme = {
  breakpoint: {
    small: `(max-width: 456px)`,
    medium: `(max-width: 700px)`,
  },
  margin: {
    medium: 24,
    large: 32,
  },
  fontFamily: {
    gothamXNarrow: '"GothamXNarrow", Helvetica, Tahoma, sans-serif',
    gothamCondensed: '"GothamCondensed", Helvetica, Tahoma, sans-serif',
    gotham: '"Gotham", Helvetica, Tahoma, sans-serif',
  },
};
